import angular from 'angular';


import officeInfoController from './officeInfoController';
import ContactInfoDirective from './contactInfo/hpContactInfo';
import OfficeAddressDirective from './address/hpOfficeAddress';
import ActiveStatesDirective from './state/hpActiveStates';

export default angular.module('app.accounts.offices.info', [])
    .controller('OfficeInfoController', officeInfoController)
    .directive('hpContactInfo', ContactInfoDirective)
    .directive('hpOfficeAddress', OfficeAddressDirective)
    .directive('hpActiveStates', ActiveStatesDirective)
    .run(($templateCache) => {
        $templateCache.put('app/accounts/offices/info/address/officeAddress.html', require('./address/officeAddress.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/info/contactInfo/contactInfo.html', require('./contactInfo/contactInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/info/state/activeStates.html', require('./state/activeStates.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/info/officeInfo.html', require('./officeInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/info/editContacts.html', require('./editContacts.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/info/editInfo.html', require('./editInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/info/viewContacts.html', require('./viewContacts.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/info/viewInfo.html', require('./viewInfo.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/accounts/offices/info/index.js